export default __webpack_public_path__ + "static/media/deplier.7247dad8.svg";